
"use strict";
angular.module("registrationAuditServiceModule", [
    "registerPersonalModule",//pgc注册用户的资料审核
    "regAuditFailModule",//审核不通过
    "channelAuditModule",//渠道审核
    "channelAuditFailModule",//渠道审核不通过
]).
factory("registrationAuditService", ["$modal", "$q", function($modal, $q) {
    return {

        /**
         * [registerPersonal description] 注册资料个人
         * @param {[string]} [content] [description] 内容
         */
        registerPersonal: function(userId,channelId) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/registrationAudit/service/registerPersonal/registerPersonal_tpl.html",
                windowClass: 'registerPersonal backstageModalHeader',
                backdrop: false,
                controller: "registerPersonalCtrl",
                resolve: {
                    userId: function() {
                        return userId;
                    },
                    channelId:function(){
                    	return channelId;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },
        /**
         * [registerPersonal description] 审核不通过
         * @param {[string]} [content] [description] 内容
         */
        regAuditFail: function(userId,channelId) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/registrationAudit/service/registerPersonal/regAuditFail/regAuditFail_tpl.html",
                windowClass: 'regAuditFail backstageModalHeader',
                backdrop: false,
                controller: "regAuditFailCtrl",
                resolve: {
                    userId: function() {
                        return userId;
                    },
                    channelId:function(){
                    	return channelId;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },
        
        /**
         * [channelAudit description] 渠道审核 
         * @return {[type]} [description]
         */
		channelAudit: function(userId,channelId){
			var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/registrationAudit/service/channelAudit/channelAudit_tpl.html",
                windowClass: 'channelAudit',
                backdrop: false,
                controller: "channelAuditCtrl",
                resolve: {
                    userId: function() {
                        return userId;
                    },
                    channelId:function(){
                    	return channelId;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
		},
		/**
         * [channelAuditFail description] 渠道审核不通过 
         * @return {[type]} [description]
         */
		channelAuditFail: function(userId,channelId){
			var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/userManagement/registrationAudit/service/channelAudit/channelAuditFail/channelAuditFail.html",
                windowClass: 'regAuditFail',
                backdrop: false,
                controller: "channelAuditFailCtrl",
                resolve: {
                    userId: function() {
                        return userId;
                    },
                    channelId:function(){
                    	return channelId;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
		},
    };
}]);